import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import ProtectedRoute from '../components/ProtectedRoute';
import HomePage from './../website/pages/HomePage';
import UserList from '../pages/tables/CommonTable';
import { userList,blogList } from '../utils/TableHeads/TableHeadRow';
import { AdminFeatures } from '../utils/AdminFeatures/Features';
import CommonTable from '../pages/tables/CommonTable';
import UserCreate from '../pages/user/UserCreate';
import BlogCreate from '../pages/blogs/BlogCreate';

// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('../pages/dashboard/default')));

// render - color
const Color = Loadable(lazy(() => import('../pages/component-overview/color')));
const Typography = Loadable(lazy(() => import('../pages/component-overview/typography')));
const Shadow = Loadable(lazy(() => import('../pages/component-overview/shadows')));

// render - sample page
const SamplePage = Loadable(lazy(() => import('../pages/extra-pages/sample-page')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <DashboardLayout />,
  children: [
    {
      path: '/admin',
      element: (
        <ProtectedRoute>
          <DashboardDefault />
        </ProtectedRoute>
      )
    },
    {
      path: '/',
      children: [
        {
          path: 'dashboard',
          element: (
            <ProtectedRoute>
              <DashboardDefault />
            </ProtectedRoute>
          )
        }
      ]
    },
    {
      path: 'users',
      element: (
        <ProtectedRoute>
          <CommonTable tableHeads= {userList} title={"User List"} typo={"Users"} feature={AdminFeatures.USER_MANAGEMENT} buttonText = {"Add User"} buttonRoute {..."users"} />
        </ProtectedRoute>
      )
    },
    {
      path: 'users/create',
      element: (
        <ProtectedRoute>
          <UserCreate/>
        </ProtectedRoute>
      )
    },
    {
      path: 'blogs/create',
      element: (
        <ProtectedRoute>
          <BlogCreate/>
        </ProtectedRoute>
      )
    },
    {
      path: 'blog-list',
      element: (
        <ProtectedRoute>
          <CommonTable tableHeads= {blogList} title={"Blogs"} typo={"Blogs"} feature={AdminFeatures.BLOG_MANAGEMENT} buttonText = {"create blog"} buttonRoute = {"/blogs/create"} />
        </ProtectedRoute>
      )
    }
  ]
};

export default MainRoutes;
